import React, { Children } from "react"
import Layout from "./Layout"
import style from "./Hub.module.scss"

export default ({ links, children }) => {
  return (
    <Layout>
      <section className={style.container}>
        <nav>
          {links}
        </nav>
        <article>
          {children}
        </article>
      </section>
    </Layout>
  )
}
